import React, { useRef, useState, useEffect } from 'react';
import * as request from "../../services/FetchService";
import { useIsMobile } from '../../helpers/customHooks';
import MassShareDeviceRow from '../Devices/MassShareDeviceRow';
import { useTranslation } from 'react-i18next';
import { icons } from '../../helpers/constants';
import MassShareModal from '../Modals/MassShareModal';
import NewButton from '../Buttons/NewButton';
import toast from 'react-hot-toast';

const MassSharingContent = ({show}) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [devices, setDevices] = useState()
    const [showModal, setShowModal] = useState(false)
    const [allSelected, setAllSelected] = useState(false)
    const [loading, setLoading] = useState(true)


    const getShareStuff = () => {
        request.get("events/share/list").then((response) => {
            setDevices(response.data)
            setLoading(false)
        });
    }

    const handleClose = () => {
        setShowModal(false)
        setAllSelected(false)
        if(devices?.length>0){
            let updatedDevices = [...devices];
            updatedDevices.map((device, index) => {
                device.selected = false
            })
            setDevices(updatedDevices)
        }
    }


    useEffect(() => {
        if(show){
           getShareStuff() 
        }
    }, [show])
    const addEmail = () => {

    }
    const selectDevice = (index) => {
        const updatedDevices = [...devices];
        if (index !== -1) {
            var device = updatedDevices[index];
            if (device.selected !== true){
                device.selected = true;
            }else{
                device.selected = false;
            } 
            updatedDevices[index] = device;
            setDevices(updatedDevices);
          }
    }

    useEffect(() => {
        if(allSelected && devices?.length > 0){
            let updatedDevices = [...devices];
            updatedDevices.map((device, index) => {
                device.selected = true
            })
            setDevices(updatedDevices)
        }else{
            if(devices?.length>0){
                let updatedDevices = [...devices];
                updatedDevices.map((device, index) => {
                    device.selected = false
                })
                setDevices(updatedDevices)
            }
        }
    }, [allSelected])

    const handleSave = (arrays) => {
        if(arrays.removed?.length > 0){
            const data = {
                deviceid: devices.filter(dev => dev.selected).map(dev => dev.deviceid),
                email: arrays?.removed
            }
            request.post("", "events/share/delete", data).then((response) => {
                if(response.data.successful){
                    toast.success(t("settings.emails_deleted"))
                }
            })
        }
        if(arrays.added?.length > 0){
            const data = {
                deviceid: devices.filter(dev => dev.selected).map(dev => dev.deviceid),
                email: arrays?.added
            }
            request.post("", "events/share/add", data).then((response) => {
                if(response.data.successful){
                    toast.success(t("settings.emails_added"))
                }
            })
        }
        setTimeout(() => {
            handleClose()
            getShareStuff() 
        }, 500);
    }
    
    return(
        <>

            <div className={`margin-x-20 d-flex justify-content-between mt-3`}>
                <div className ="d-flex align-self-end ms-3 align-items-center cursor pointer mb-2" onClick={() => setAllSelected(!allSelected)}>
                    <div className={`me-2 ${devices?.every(email => email.selected) ? "bg-checked" : "bg-grey"} size_20 border-sm d-flex justify-content-center p-1`}>
                        {devices?.every(email => email.selected) && <img className="white-icon" src={icons.check} alt={""} />}
                    </div>
                    <p>{t("events.select_all")}</p>
                </div>
                <NewButton 
                    className={`bg-white grey-blue rounded24 mb-2 ${devices?.some(dev => dev.selected) ? "" : "disabled"}`} 
                    onClick={() => setShowModal(true)}>{t("events.handle_share")}</NewButton>
            </div>
            <div className={`margin-x-20 rounded24 overflow-hidden border-bottom-24 margin-bottom-20`}>

                {devices?.map((dev, index) => (
                    <div key={index} className="overflow-hidden cursor-pointer">
                        <div className={`d-flex p-3 align-items-center cursor-pointer bg-white`} onClick={() => selectDevice(index)}>
                            <div className={`me-3 ${dev?.selected ? "bg-checked" : "bg-grey"} size_20 border-sm d-flex justify-content-center p-1`}>
                                {dev?.selected && <img className="white-icon" src={icons.check} alt={""} />}
                            </div>
                            <div className="d-flex flex-column">
                                <div className="body m-0 p-0 bold">{dev.devicename}</div>
                                <p className="m-0 p-0 dark-grey">{dev.uniqueid}</p>
                            </div>
                            <div className="d-flex flex-column ms-auto align-items-end">
                                <p className="m-0 p-0 bold">{`${dev.shared.shared ? t("events.shared") : t("events.not_shared")}`}</p>
                                <p className="m-0 p-0 thin dark_grey align-self-end">{t("events.to_account_amount", {count: dev.shared.amount})}</p>
                                <p>{dev.shared.amount}</p>
                            </div>
                        </div>
                        <hr className='m-0 p-0 event-divider bg-light-grey' />
                    </div>
                    // <MassShareDeviceRow device={dev} addEmail={(data) => addEmail(data)} getDevices={() => getShareStuff()} index={index} key={index} checkboxVisibility={deviceActionToggle} setDeviceToggle={(data) => selectDevice(index)}/>
                ))}
            </div>
            <MassShareModal show={showModal ?? false} onSave={(array) => handleSave(array)} addEmail={(data) => addEmail(data)} selectedDevices={devices?.filter(device => device.selected)} onClose={() => handleClose()} />
        </>
    )
}

export default MassSharingContent;